module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0092.jpg?v=b0892791";